import { ViewIds } from '@ardoq/api-types';
import { getLeftMenu, getRightMenu } from 'tabview/blockDiagram/menus';
import { connect, useStream } from '@ardoq/rxbeach';
import { scenarioIsInSync$ } from 'scenarioIsInSync$';
import { quickPerspectiveReferenceTypeFilters$ } from 'streams/filters/quickPerspectiveReferenceTypeFilters$';
import { combineLatest } from 'rxjs';
import type {
  AggregatedReferenceType,
  OnViewSettingsUpdate,
} from '@ardoq/data-model';
import type { BlockDiagramViewSettings } from 'tabview/blockDiagram/types';
import { getIsViewBusy$ } from '../isViewBusy$';
import { SettingsBar, SettingsBarProps } from '@ardoq/settings-bar';
import type { I18nLocale } from '@ardoq/i18n';

type ScenarioSyncedSettingsBarProps = {
  scenarioIsInSync: { isInSync: boolean };
  quickPerspectiveReferenceTypeFilters: Set<string> | null;
  viewSettings: BlockDiagramViewSettings;
  viewInstanceId: string;
  i18nLocale?: I18nLocale;
  getRightMenuArgs: Omit<
    Parameters<typeof getRightMenu>[0],
    | 'viewSettings'
    | 'isInSync'
    | 'isViewpointMode'
    | 'additional'
    | 'i18nLocale'
  >;
  getLeftMenuArgs: {
    traversedOutgoingReferenceTypes: AggregatedReferenceType[];
    traversedIncomingReferenceTypes: AggregatedReferenceType[];
    referenceTypes: AggregatedReferenceType[];
    viewId: ViewIds.BLOCK_DIAGRAM | ViewIds.METAMODEL;
    onViewSettingsUpdate: OnViewSettingsUpdate;
    activeGroups: string[];
    isViewpointMode: boolean;
  };
} & Omit<SettingsBarProps, 'rightMenu' | 'leftMenu'>;

const ScenarioSyncedSettingsBarBase = ({
  scenarioIsInSync,
  quickPerspectiveReferenceTypeFilters,
  getRightMenuArgs,
  getLeftMenuArgs,
  viewSettings,
  viewInstanceId,
  viewId,
  i18nLocale,
  ...props
}: ScenarioSyncedSettingsBarProps) => {
  const isViewBusy = useStream(getIsViewBusy$(viewInstanceId));

  return (
    <SettingsBar
      {...props}
      rightMenu={getRightMenu({
        ...getRightMenuArgs,
        viewSettings,
        isViewpointMode: false,
        isInSync: scenarioIsInSync.isInSync,
        i18nLocale,
      })}
      leftMenu={getLeftMenu({
        ...getLeftMenuArgs,
        isViewBusy: Boolean(isViewBusy),
        viewSettings,
        viewInstanceId,
        quickPerspectiveReferenceTypeFilters,
        i18nLocale,
      })}
      viewId={viewId}
      i18nLocale={i18nLocale}
    />
  );
};

export const ScenarioSyncedSettingsBar = connect(
  ScenarioSyncedSettingsBarBase,
  combineLatest({
    scenarioIsInSync: scenarioIsInSync$,
    quickPerspectiveReferenceTypeFilters: quickPerspectiveReferenceTypeFilters$,
  })
);
